<template>
  <a-modal
    v-model="visible"
    :title="title || modalTitle"
    :destroy-on-close="true"
    :footer="null"
    wrap-class-name="fullscreen-modal"
    dialog-class="answer-modal"
    width="auto"
    :z-index="1100"
    :after-close="afterClose"
  >
    <div class="modal-content">
      <div class="answer-overall">
        <div
          :class="[
            'answer-score',
            textEvaluate.result.scoreRate >= 85
              ? 'col-1DC060'
              : textEvaluate.result.scoreRate >= 60
                ? 'col-FFA516'
                : 'col-FF3C30'
          ]"
        >
          <template v-if="$store.getters.isGradeSchool">
            <img :src="Grade2ImgSrc(Number(textEvaluate.result.overall))" alt="" class="score-img" />
          </template>
          <template v-else>
            <span class="score">{{ Number(textEvaluate.result.overall).toFixed(2) }}</span>
            <span class="text">分</span>
          </template>
        </div>
        <div class="answer-star">
          <template v-for="index in 5">
            <img
              :key="index"
              class="answer-star-img"
              :src="
                index <= fetchStarNum(textEvaluate.result.scoreRate)
                  ? require('@/assets/common/star_highlight.png')
                  : require('@/assets/common/star_grey.png')
              "
              alt=""
            />
          </template>
        </div>
      </div>
      <div class="answer-evaluate">
        <div
          :class="[
            'answer-text',
            'mb-15',
            textEvaluate.result.scoreRate >= 85
              ? 'col-1DC060'
              : textEvaluate.result.scoreRate >= 60
                ? 'col-FFA516'
                : 'col-FF3C30'
          ]"
        >
          {{ textEvaluate.refText }}
        </div>
        <div v-if="textEvaluate.result.details" class="word-evaluate">
          <div class="word-evaluate-container">
            <template v-for="detail in textEvaluate.result.details">
              <template v-for="(item, index) in detail.phone">
                <PhoneProgress :key="index" :ratio="item.score" :content="item.char" />
              </template>
            </template>
          </div>
        </div>
      </div>
      <div class="answer-audio" @click="audioPlay(textEvaluate.audioUrl)">
        <img class="radius-icon radius-left" :src="require('@/assets/common/radius_bottom_left_gray.png')" alt="" />
        <img
          v-if="isPlaying"
          class="answer-audio-icon mb-10"
          :src="require('@/assets/common/record_play_black.gif')"
          alt=""
        />
        <img v-else class="answer-audio-icon mb-10" :src="require('@/assets/common/record_play_black.png')" alt="" />
        <span>学生录音</span>
        <img class="radius-icon radius-right" :src="require('@/assets/common/radius_bottom_right_gray.png')" alt="" />
        <audio ref="audio" class="answer-audio" @play="onplay" @pause="onpause" />
      </div>
    </div>
  </a-modal>
</template>

<script>
import PhoneProgress from '@/components/answer/PhoneProgress'
import { Grade2ImgSrc } from '@/utils'

export default {
  name: 'WordEvaluateModel',
  components: { PhoneProgress },
  props: {
    // textEvaluate: {
    //   type: Object,
    //   default: () => {
    //     return {
    //       result: {
    //         overall: 0
    //       }
    //     }
    //   }
    // },
    // title: {
    //   type: String,
    //   default: () => ''
    // }
  },
  data() {
    return {
      visible: false,
      answerPlaying: false,
      isPlaying: false,
      playAfterShow: false, // 弹窗展示后自动播放
      title: '',
      textEvaluate: {
        result: {
          overall: 0
        },
        audioUrl: ''
      },
      onClose: null
    }
  },
  computed: {
    modalTitle() {
      return this.$store.getters.activeAnswer && this.$store.getters.activeAnswer.id
        ? (this.$store.getters.activeAnswer.realName || this.$store.getters.activeAnswer.name) + '的作答详情'
        : '作答详情'
    }
  },
  methods: {
    Grade2ImgSrc,
    changeVisible(bol) {
      this.visible = bol
      this.answerPlaying = false
      this.$nextTick(() => {
        if (this.visible && this.playAfterShow) {
          this.audioPlay(this.textEvaluate.audioUrl)
        }
      })
    },
    // 获取得分星星数量
    fetchStarNum(scoreRate) {
      scoreRate = Number(scoreRate)
      if (scoreRate >= 80) {
        return 5
      } else if (scoreRate >= 60) {
        return 4
      } else if (scoreRate >= 40) {
        return 3
      } else if (scoreRate >= 20) {
        return 2
      } else {
        return 1
      }
    },
    // 播放音频
    audioPlay(text) {
      if (this.answerPlaying) {
        this.$refs.audio.pause()
      } else {
        this.$refs.audio.src = text
        this.$refs.audio.addEventListener('play', () => {
          this.isPlaying = true
        })
        this.$refs.audio.addEventListener('ended', () => {
          this.isPlaying = false
        })
        this.$refs.audio.addEventListener('pause', () => {
          this.isPlaying = false
        })
        this.$refs.audio.play()
      }
    },
    // 音频播放事件
    onplay() {
      this.answerPlaying = true
    },
    // 音频暂停事件
    onpause() {
      this.answerPlaying = false
    },
    afterClose() {
      if (typeof this.onClose === 'function') {
        this.onClose(this)
      }
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-modal-wrap {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

::v-deep .ant-modal {
  max-width: 100vw;
  min-width: 450px;

  &.answer-modal {
    .ant-modal-content {
      border-radius: 24px;

      .ant-modal-header {
        height: 72px;
        background: url('@/assets/common/model_title.png');
        background-size: 100% 72px;
        border-radius: 24px 24px 0 0;
        padding: 22px 40px;

        .ant-modal-title {
          color: #333333;
          font-size: 20px;
          line-height: 28px;
          font-weight: bold;
        }
      }

      .ant-modal-close {
        top: 14px;
        right: 14px;

        .ant-modal-close-x {
          width: 44px;
          height: 44px;
          line-height: 44px;
        }
      }

      .ant-modal-body {
        border-radius: 0 0 24px 24px;
        padding: 0;

        .modal-content {
          .answer-overall {
            width: 330px;
            height: 105px;
            padding: 20px 0;
            margin: 0 60px 60px;
            border-bottom: 1px solid #f1f1f1;
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;

            .answer-score {
              display: flex;
              align-items: center;

              .score {
                font-size: 34px;
              }

              .text {
                margin-left: 4px;
                font-size: 18px;
              }
            }

            .answer-star {
              .answer-star-img {
                width: 16px;
                height: 16px;

                & + .answer-star-img {
                  margin-left: 4px;
                }
              }
            }
            .score-img {
              width: 48px;
              height: 48px;
            }
          }

          .answer-evaluate {
            display: flex;
            flex-flow: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 70px;

            .answer-text {
              font-size: 44px;
              line-height: 62px;
              font-weight: bold;
              color: #1dc060;
              text-align: center;
            }

            .word-evaluate {
              width: 100%;
              overflow-x: auto;
              //width: calc(100% - 80px);
              padding: 0 20px;
              display: flex;
              justify-content: center;

              .word-evaluate-container {
                display: flex;
                justify-content: center;
                width: 100%;

                &::-webkit-scrollbar {
                  height: 8px !important;
                }

                // 滚动条里面滑块
                &::-webkit-scrollbar-thumb {
                  border-radius: 8px !important;
                  border: 0;
                  /* 颜色 */
                  background: rgba(0, 0, 0, 0.1) !important;
                }
              }
            }
          }

          .answer-audio {
            margin: 0 auto;
            width: 84px;
            height: 107px;
            font-size: 12px;
            line-height: 17px;
            padding: 20px 17px 10px;
            color: #1976ff;
            text-align: center;
            border-radius: 58px 58px 0 0;
            background: linear-gradient(180deg, #fbfbfb 0%, #f6f6f6 100%);
            position: relative;

            .answer-audio-icon {
              width: 50px;
              height: 50px;
            }

            .radius-icon {
              position: absolute;
              bottom: 0;
              width: 20px;
              height: 20px;

              &.radius-left {
                left: -20px;
              }

              &.radius-right {
                right: -20px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
